module.exports = __webpack_public_path__ + "static/media/img-scheduling-logo.27cfca50.svg";